import { FC } from 'react';
import { Image, Skeleton } from "antd";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenLayout } from "../ScreenLayout";
import { ScreenButton } from "../ScreenButton";
import cross from "../../images/cross-red.png";
import styles from './index.module.scss'

export const OrderNotFoundScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout hiddenTabs>
      <Image
        className={styles.image}
        width={150}
        height={150}
        alt="profile"
        preview={false}
        src={cross}
      />
      <div className={styles.body}>
        <div className={styles.title}>
          Заказа 123564321 <br/>
          пока нет в системе.
        </div>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          Понятно
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}